/* LAH GRAU/SOL — correspondencia de cor em tempo real

   O seletor de cor (custom-variant-picker.liquid) troca a variante só no
   client-side via Alpine (@click="changeVariant(...)"), sem recarregar a
   pagina. Os links "Grau"/"Sol" sao calculados uma unica vez no servidor,
   entao nao acompanhavam uma troca de cor feita depois do carregamento.

   Este script escuta o clique nas cores (delegacao de evento, sem tocar
   no Alpine) e atualiza o href do link que aponta para a outra versao
   (grau<->sol), usando o mapa cor->variant_id do produto correspondente
   que o Liquid ja embute na pagina (script#lah-gs-color-map).

   Reversao: apagar este arquivo e a tag <script> que o carrega em
   custom-product-media.liquid. */

(function () {
    'use strict';

    function updateCounterpartLinks(skuBase) {
        if (!skuBase) return;

        var mapEl = document.getElementById('lah-gs-color-map');
        if (!mapEl) return;

        var map;
        try {
            map = JSON.parse(mapEl.textContent);
        } catch (e) {
            return;
        }

        var variantId = map[skuBase];

        document.querySelectorAll('a[data-lah-counterpart="1"]').forEach(function (link) {
            var baseUrl = link.getAttribute('data-lah-base-url');
            if (!baseUrl) return;
            link.href = variantId ? (baseUrl + '?variant=' + variantId) : baseUrl;
        });
    }

    document.addEventListener('click', function (event) {
        var swatch = event.target.closest ? event.target.closest('.color-picker-swatch-item[data-lah-sku-base]') : null;
        if (!swatch) return;
        updateCounterpartLinks(swatch.getAttribute('data-lah-sku-base'));
    });
})();
